import axios from "axios";
import { toast } from "react-toastify";
import { APIURL } from "./config";

export const createDiscount = async (requestBody) => {
    try {
        const token = localStorage.getItem("token");
        var config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.post(`${APIURL}/api/v1/discount/create`, requestBody, config);
        toast.success(response?.data?.message);
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message);
    }
};

export const discountCouponList = async () => {
    try {
        const token = localStorage.getItem("token");
        var config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${APIURL}/api/v1/discount/list`, config);
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message);
    }
};

export const updateDiscount = async (requestBody) => {
    try {
        const token = localStorage.getItem("token");
        var config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.put(`${APIURL}/api/v1/discount/${requestBody._id}`, requestBody, config);
        toast.success(response?.data?.message);
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message);
    }
};

export const deleteDiscount = async (requestBody) => {
    try {
        const token = localStorage.getItem("token");
        var config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.delete(`${APIURL}/api/v1/discount/${requestBody}`, config);
        toast.success(response?.data?.message);
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message);
    }
};